export default __webpack_public_path__ + "static/media/arrow-up.12e1843f.svg";